<template>
  <v-app id="inspire">
    <div>
      <div v-if="loading" class="loader">
        <div :class="`d-flex justify-center`">
          <pixel-spinner
            :animation-duration="1200"
            :size="120"
            :color="'#aaa'"
            />
        </div>
      </div>
      <div v-else>
        <v-main>
          <v-container
            class="fill-height"
            fluid
          >
            <v-row
              align="center"
              justify="center"
              rows="6"
            >
              <v-col
                cols="12"
                sm="8"
                md="4"
              >
                <h3 v-if="badResponse" :class="`d-flex justify-center`"
                style="text-align: center;">
                  Please try another image and make sure you searched the correct book.
                  Sometimes glare is a problem.
                  <br>
                  <br>
                </h3>
                <h3 :class="`d-flex justify-center`">Find Your Next Grail</h3>
                <br>
                <v-text-field
                  label="Slab you want"
                  name="textIn"
                  type="text"
                  v-model.lazy="search.title"
                  v-on:keyup.enter="imageFocus()"
                ></v-text-field>
                <br>
                <v-spacer></v-spacer>
                <div :class="`d-flex justify-center`">
                  <v-btn @click="findImage()" :disabled="false" ref="verify"
                  style="margin: 10px 30px 30px 30px;"> Find Images </v-btn>
                </div>
                <div v-for="(book, index) in imageList" :key="index" :delay="100">
                  <v-spacer></v-spacer>
                  <v-img :src=book @click="showResults(book)"
                    :class="`d-flex justify-center`"
                    max-height="300"
                    contain
                    style="cursor: pointer;"></v-img>
                  <br>
                  <br>
                  <v-divider></v-divider>
                  <br>
                </div>

                <!--<v-text-field
                  label="URL to an image of the slab you want"
                  id="imageIn"
                  name="imageIn"
                  type="text"
                  ref="imageSearch"
                  v-model.lazy="search.image"
                  v-on:keyup.enter="verifyFocus()"
                ></v-text-field>
                <br>
                <v-h3>Please verify your search</v-h3>
                <v-spacer></v-spacer>
                <div :class="`d-flex justify-center`">
                  <v-btn @click="required()" :disabled="false" ref="verify"
                  style="margin: 10px 30px 30px 30px;"> Looks Good! </v-btn>
                </div>
                <div :class="`d-flex justify-center`">
                  <v-img v-bind:src=search.image
                    max-height="300"
                    contain></v-img>
                </div>
                <br>
                <div :class="`d-flex justify-center`">
                  <v-btn @click="showResults()" :disabled="this.cannotRun">
                    Search!
                  </v-btn>
                </div>-->
                <br>
              </v-col>
            </v-row>
          </v-container>
        </v-main>
      </div>
      <h6 class="bottomRight" @click="openNewTab('https://www.youtube.com/channel/UC2iZ7zmT7D35eT_nofMo_9A')">How To Use</h6>
    </div>
  </v-app>
</template>

<script>
import axios from 'axios';
import { mapMutations } from 'vuex';
import { PixelSpinner } from 'epic-spinners';

export default {
  name: 'SearchPage',
  props: {
    msg: String,
  },
  created() {
    this.search.title = '';
    this.search.image = '';
    this.loading = false;
    this.cannotRun = true;
    this.badResponse = false;
    this.imageList = [];
  },
  components: {
    PixelSpinner,
  },
  methods: {
    ...mapMutations(['updateSearchResults']),
    ...mapMutations(['resetSearchResults']),
    onEnter() {
      this.required();
    },
    openNewTab(url) {
      window.open(url);
    },
    imageFocus() {
      this.$refs.imageSearch.focus();
    },
    verifyFocus() {
      this.$refs.verify.focus();
    },
    required() {
      const textArg = this.search.title;
      const imageArg = this.search.image;
      if (textArg.length > 3) {
        if (imageArg.length > 3) {
          this.cannotRun = false;
        }
      } else {
        this.cannotRun = true;
      }
    },
    findImage() {
      axios.get(`https://www.googleapis.com/customsearch/v1?key=AIzaSyA2mL-GD9ai410gWWIsxYS1WK6fo1FsEX4&cx=8bb5985876516bd4f&q=${this.search.title} cgc\n&searchType=image`)
        .then((response) => {
          this.imageList = [];
          // eslint-disable-next-line no-restricted-syntax
          for (const item of Object.values(response.data.items)) {
            this.imageList.push(item.link);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    showResults(bookIn) {
      this.search.image = bookIn;
      this.resetSearchResults();
      this.loading = true;
      axios.post('https://cc-backend-ob5cwhmgpq-uc.a.run.app/api', {
        text: this.search.title,
        image: this.search.image,
      }).then((response) => {
        // eslint-disable-next-line no-restricted-syntax
        for (const book of Object.values(response.data)) {
          this.updateSearchResults(book);
        }
        this.loading = false;

        this.$router.push('Results');
      }).catch((error) => {
        console.log(error.response.data);
        this.loading = false;
        this.badResponse = true;
      });
    },
  },
  data() {
    return {
      search: {
        title: '',
        image: '',
      },
      imageList: '',
      loading: false,
      cannotRun: true,
      badResponse: false,
    };
  },
};
</script>

<style scoped>

.centered {
  position: fixed; /* or absolute */
  top: 40%;
  left: 50%;
}
.bottomRight {
  position: absolute; /* or absolute */
  bottom: 0;
  right: 5px;
  text-align: right;
  color: #212ff1;
  text-decoration: underline;
  cursor: pointer;
}
</style>
